import React, {Component} from 'react';
import {Button, DatePicker, Form, Input, message, Select} from 'antd';

import moment from 'moment';
import {queryAccountList} from '@api/core/user';
import './flowSearch.less';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

class FlowSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
    };
  }

  componentDidMount() {
    this.getAccountList();
  }

  // 用户列表
  getAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          userList: res.data || [],
        });
      } else {
        message.err(res.message, 2.5);
      }
    });
  };

  onSearch = () => {
    const data = this.props.form.getFieldsValue();
    let params = {};
    const { date } = data;
    if (date && date.length > 0) {
      params = {
        beginDate: moment(date[0]).format('YYYY-MM-DD'),
        endDate: moment(date[1]).format('YYYY-MM-DD'),
      };
    }
    params = {
      ...params,
      condition: data.condition || '',
      createUser: data.createUser || '',
      instanceStatus: data.instanceStatus || '',
    };
    this.props.onSearch(params);
  };

  render() {
    const {
      form: { getFieldDecorator },
      instanceStatus,
      endDate,
      beginDate,
      condition,
      createUser,
    } = this.props;
    const { userList } = this.state;
    return (
      <div className="expense-search-form">
        <Form layout="inline" style={{ textAlign: 'right' }}>
          <FormItem label="模糊搜索" labelCol={6} wrapperCol={18}>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="公司/理由/申请人/等等" />)}
          </FormItem>
          <FormItem label="申请人" labelCol={6} wrapperCol={18}>
            {getFieldDecorator('createUser', {
              initialValue: createUser || undefined,
            })(
              <Select
                allowClear
                showSearch
                placeholder="根据申请人搜索"
                style={{ width: '150px' }}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {userList
                  ? userList.map(item => {
                      return (
                        <Select.Option key={item.uuid} value={item.uuid}>
                          {item.name}
                        </Select.Option>
                      );
                    })
                  : null}
              </Select>,
            )}
          </FormItem>
          <FormItem label="状态" labelCol={6} wrapperCol={18}>
            {getFieldDecorator('instanceStatus', {
              initialValue: instanceStatus || undefined,
            })(
              <Select allowClear placeholder="根据状态搜索" style={{ width: '150px' }}>
                <Select.Option key={0} value="NO">
                  待编辑
                </Select.Option>
                <Select.Option key={0} value="REVIEWING">
                  审核中
                </Select.Option>
                <Select.Option key={1} value="FINISHED">
                  已完成
                </Select.Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="起止日期" labelCol={4} wrapperCol={20}>
            {getFieldDecorator('date', {
              initialValue: beginDate
                ? [moment(beginDate, 'YYYY-MM-DD'), moment(endDate, 'YYYY-MM-DD')]
                : null,
            })(<RangePicker format="YYYY-MM-DD" />)}
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={this.onSearch}>
              搜索
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(FlowSearch);



// WEBPACK FOOTER //
// ./src/components/comm/FlowSearch.js